module.exports = __webpack_public_path__ + "media/assets/images/flags/eg-7f10257e6771106749aabf0ff7988153.svg";